import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    active_tab: 'certificates',
    active_tab_text: 'Сертификаты',
    more: {
      active: false,
      data: {}
    }
  },
  mutations: {
    setActiveTab(state, tab) {
      if (tab == 'booking') {
        state.active_tab = 'booking'
        state.active_tab_text = 'Онлайн записи'
      }
      if (tab == 'certificates') {
        state.active_tab = 'certificates'
        state.active_tab_text = 'Сертификаты'
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
